
























import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
const AuthModule = namespace('AuthModule')

@Component({})
export default class SignIn extends Vue {
  email: string = '';
  password: string = '';

  @AuthModule.Action('login') login: any;
  @AuthModule.Getter('authenticating') authenticating!: boolean;

   onLoginClick() {
      if (this.email != '' && this.password != '') {
        this.login({email: this.email, password: this.password})
        this.password = ""
      }
   }
}
